import React from 'react';

//styling

interface IProps {
  number: string;
}

import { ForwardRefRenderFunction } from 'react';

const CountAnimation: ForwardRefRenderFunction<HTMLSelectElement, IProps> = ({
  number,
}) => {
  const [count, setCount] = React.useState('0');
  React.useEffect(() => {
    let start = 0;
    const end = parseInt(number.substring(0, 3));
    // if zero, return
    if (start === end) return;

    // find duration per increment
    let totalMilSecDur = parseInt('2');
    let incrementTime = (totalMilSecDur / end) * 1000;

    let timer = setInterval(() => {
      start += 1;
      setCount(String(start) + number.substring(3));
      if (start === end) clearInterval(timer);
    }, incrementTime);
  }, [number]);

  return <span>{count}</span>;
};

export default CountAnimation;
